// src/hooks/paxTypes/useForceDeleteAllPaxTypes.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllPaxTypes as forceDeleteAllPaxTypesAPI } from "../../api/apiPaxTypes";
import parseError from "../../utils/parseError";

const useForceDeleteAllPaxTypes = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAll, isPending: isForceDeleteAll } = useMutation({
        mutationFn: forceDeleteAllPaxTypesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected pax types permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["paxTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete selected pax types");
        },
    });

    return { forceDeleteAllPaxTypes: forceDeleteAll, isForceDeleteAll };
};

export default useForceDeleteAllPaxTypes;